import React from 'react'
import Android from '../../../../assets/premium/android.png'
import { theme } from '../../../../theme'

function AndroidIcon({ size = 1, color }) {
  return (
    <img
      alt={'Android icon'}
      style={{
        filter:
          color === theme.colors.palette.slateGrey ? 'grayscale(100%)' : '',
        marginRight: `${20 * size}px`,
      }}
      width={32 * size}
      height={32 * size}
      src={Android}
    />
  )
}

export default AndroidIcon
